import { Box, Grid, styled, Button } from '@mui/material';
import React from 'react';
import { AiVideo, ServiceVideo } from '../../sections';
import { motion } from 'framer-motion';
import getStyles from './styles';
import useMediaSize from '../../hooks/mediasize';

const VideoContainer = styled(motion.div)(() => ({
  position: 'relative',
  borderRadius: '16px',
  height: '92vh',
  overflow: 'hidden',
  cursor: 'pointer',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3)'
  }
}));

const VideoWrapper = styled(Box)(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
}));

const VideoOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background:
    'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.2) 100%)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(3),
  color: 'white',
  opacity: 0,
  transition: 'opacity 0.3s ease',
  '&:hover': {
    opacity: 1
  }
}));

const ClickButton = styled(Button)(() => ({
  background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
  border: 0,
  borderRadius: 12,
  color: 'white',
  padding: '10px 24px',
  fontWeight: 'bold',
  boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
  transition: 'all 0.3s ease',
  position: 'absolute',
  bottom: '5%',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0 5px 8px 2px rgba(33, 203, 243, .4)',
    background: 'linear-gradient(45deg, #2196F3 40%, #21CBF3 100%)'
  }
}));

const LogoOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '10%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 10,
  [theme.breakpoints.down('md')]: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    transform: 'none',
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(3, 0)
  }
}));

const VideoLayout = ({ onServiceSelect }) => {
  let mediasize = useMediaSize();
  const styles = getStyles();

  return (
    <Box sx={styles.videoSection}>
      <Box sx={styles.videoBack} />
      <Box sx={{ ...styles.videoContainer, position: 'relative', zIndex: 1 }}>
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          {mediasize !== 'xs' && mediasize !== 'sm' && (
            <Grid item xs={12} sm={12} md={5} lg={5}>
              <VideoContainer
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                // onClick={() => onAiSelect()}
              >
                <VideoWrapper>
                  <AiVideo />
                  <VideoOverlay>
                    <ClickButton variant="contained">Coming Soon</ClickButton>
                  </VideoOverlay>
                </VideoWrapper>
              </VideoContainer>
            </Grid>
          )}
          {mediasize !== 'xs' && mediasize !== 'sm' && (
            <Grid item xs={12} sm={12} md={5} lg={5}>
              <VideoContainer
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => onServiceSelect()}
              >
                <VideoWrapper>
                  <ServiceVideo />
                  <VideoOverlay>
                    <ClickButton variant="contained">Click Here</ClickButton>
                  </VideoOverlay>
                </VideoWrapper>
              </VideoContainer>
            </Grid>
          )}
        </Grid>
        <LogoOverlay>
          <img
            src="/images/logo.webp"
            alt="Logo"
            className="img-fluid"
            loading="lazy"
            style={{ width: '222px' }}
          />
        </LogoOverlay>
      </Box>
    </Box>
  );
};

export default VideoLayout;
